import { Theme } from '@mui/material';
import { PortrDefaultTheme } from './schemes/portrDefault';

export function themeCreator(theme: string): Theme {
    return themeMap[theme];
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        purple: true;
    }
}

declare module '@mui/material/IconButton' {
    interface IconButtonPropsColorOverrides {
        purple: true;
    }
}

declare module '@mui/material/Fab' {
    interface FabPropsColorOverrides {
        purple: true;
    }
}

interface ExtendedColor {
    light5?: String;
    light25?: String;
    light60?: string;
}

declare module '@mui/material/styles' {
    interface Alpha {
        primary: {
            opaque?: string;
            opaque60?: string;
            3?: string;
            5?: string;
            6?: string;
            8?: string;
            10?: string;
            12?: string;
            15?: string;
            20?: string;
            30?: string;
            40?: string;
            50?: string;
            60?: string;
            70?: string;
            80?: string;
            90?: string;
            95?: string;
        };
    }

    interface AlphaOptions {
        primary: {
            opaque?: string;
            opaque60?: string;
            3?: string;
            5?: string;
            6?: string;
            8?: string;
            10?: string;
            12?: string;
            15?: string;
            20?: string;
            30?: string;
            40?: string;
            50?: string;
            60?: string;
            70?: string;
            80?: string;
            90?: string;
            95?: string;
        };
    }

    interface Palette {
        alpha?: {
            opaque60?: string;
            black?: Alpha['primary'];
            brandblue?: Alpha['primary'];
            default?: Alpha['primary'];
            success?: Alpha['primary'];
            info?: Alpha['primary'];
            primary?: Alpha['primary'];
            purple?: Alpha['primary'];
            error?: Alpha['primary'];
            secondary?: Alpha['primary'];
            orange?: Alpha['primary'];
            white?: Alpha['primary'];
            warning?: Alpha['primary'];
            gray?: Alpha['primary'];
        };
        black?: Palette['primary'] & ExtendedColor;
        brandblue?: Palette['primary'] & ExtendedColor;
        orange?: Palette['primary'];
        purple?: Palette['primary'];
        white?: Palette['primary'];
        gray?: Palette['primary'];
    }

    interface PaletteOptions {
        alpha?: {
            black?: AlphaOptions['primary'];
            brandblue?: AlphaOptions['primary'];
            default?: AlphaOptions['primary'];
            success?: AlphaOptions['primary'];
            info?: AlphaOptions['primary'];
            primary?: AlphaOptions['primary'];
            purple?: AlphaOptions['primary'];
            error?: AlphaOptions['primary'];
            secondary?: AlphaOptions['primary'];
            orange?: Alpha['primary'];
            white?: AlphaOptions['primary'];
            warning?: AlphaOptions['primary'];
            gray?: AlphaOptions['primary'];
        };
        black?: PaletteOptions['primary'];
        brandblue?: PaletteOptions['primary'] & ExtendedColor;
        success?: PaletteOptions['primary'];
        orange?: PaletteOptions['primary'];
        purple?: PaletteOptions['primary'];
        error?: PaletteOptions['primary'];
        white?: PaletteOptions['primary'];
        warning?: PaletteOptions['primary'];
        gray?: PaletteOptions['primary'];
    }

    interface Theme {
        gradients?: {
            body: string;
        };
    }

    interface ThemeOptions {
        gradients?: {
            body: string;
        };
    }
}

const themeMap: { [key: string]: Theme } = {
    PortrDefaultTheme,
};
